import React, { FC } from 'react';
import { Autocomplete, Box, InputAdornment, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { ClinicOption } from './types';

type AddClinicAutocompleteProps = {
    clinics: ClinicOption[];
    clinicsLoading: boolean;
    selectedClinics: ClinicOption[];
    onClinicSelected: (clinic: ClinicOption) => void;
};

const AddClinicAutocomplete: FC<AddClinicAutocompleteProps> = ({
    clinics,
    clinicsLoading,
    selectedClinics,
    onClinicSelected,
}: AddClinicAutocompleteProps) => {
    const { t: translate } = useTranslation(['app-settings']);
    const selectedIds = new Set(selectedClinics.map((clinic) => clinic._id));
    const options = clinics.filter((clinic) => !selectedIds.has(clinic._id));

    return (
        <Autocomplete
            options={options}
            loading={clinicsLoading}
            getOptionLabel={(option) => option.name ?? ''}
            value={null}
            onChange={(_, value) => {
                if (value) {
                    onClinicSelected(value);
                }
            }}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={translate('app-settings:OAUTH_APP_ADD_CLINIC')}
                    size="small"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <AddIcon fontSize="small" />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        ),
                    }}
                />
            )}
            renderOption={(props, option) => (
                <Box component="li" {...props} key={option._id}>
                    <Typography variant="body2">{option.name}</Typography>
                </Box>
            )}
            fullWidth
            blurOnSelect
        />
    );
};

export default AddClinicAutocomplete;
